<script>
    import { _ } from 'svelte-i18n';
    import { permissions } from '../stores/permissions.js'; 
    import { url } from '../stores/url.js'
    import { users } from '../stores/users.js'
    import { roles } from '../stores/roles.js'
    import { request } from '../functions/http-helpers.js';
    import { swalConfirm } from '../functions/html-helpers.js';
    import { onDestroy, onMount } from 'svelte';
    import UIkit from 'uikit';


    let view = 'overview';
    let bv_search = '';
    let bv_new_permission = '';
    let bv_edit_permission_id = '';
    let bv_edit_permission_name = '';
    let bv_assign_to = '';
    let bv_assign_target = '';
    let keyup_search_timeout = null;
    let filtered_permissions = [];
    let role_permissions = [];
    let user_permissions = [];
    let target_permissions = [];
    filtered_permissions = $permissions;
    $: filteredPermissions = filterPermissions($permissions, bv_search);


    /* SETUP */
    onMount(() => {
        getPermissionPivots();
    }); 



    /* HTML inserts */
    function filterPermissions() {
        return $permissions.filter(p => p.name.includes(bv_search));
    }



    /* Events */
    function setPermissionBinds(p) {
        bv_edit_permission_id = p.id;
        bv_edit_permission_name = p.name;
    }


    function changeTarget() {
        const old_target = bv_assign_target;
        bv_assign_target = '';
        setTimeout(() => {  
            bv_assign_target = old_target;
        }, 100); 
    }


    function changeAssign() {
        bv_assign_target = '';
    }


    function hasPermission(p_id) {
        if(bv_assign_to == 'user') {
            return user_permissions.some(up => bv_assign_target == up.user_id && up.permission_id == p_id) ? true : false;
        } else if(bv_assign_to == 'role') {
            return role_permissions.some(rp => bv_assign_target == rp.role_id && rp.permission_id == p_id) ? true : false;
        }
        return false;
    }



    /* GET */
    async function getPermissionPivots() {
        const [ data, error ] = await request('get', `${$url}/permission/pivots`);
        if(!error) {
            role_permissions = data.role_permissions;
            user_permissions = data.user_permissions;
        }
    }




    /* POST */
    async function savePermission() {
        const [ data, error ] = await request('post', `${$url}/permission/create`, {
            name: bv_new_permission
        });
        if(!error) {
            bv_new_permission = '';
            filtered_permissions = [...filtered_permissions, data]; 
            $permissions = filtered_permissions;
        }
    }



    /* UPDATE */  
    async function updatePermission() {
        const [ data, error ] = await request('put', `${$url}/permission/update/${bv_edit_permission_id}`, {
            name: bv_edit_permission_name
        }); 
        if(!error) {
            UIkit.modal('#m_edit_permission').hide();
            filtered_permissions.find(p => p.id == bv_edit_permission_id).name = bv_edit_permission_name;
            filtered_permissions = filtered_permissions;
            $permissions = filtered_permissions;
        }
    }


    async function asignPermission(p_id) { // bv_assign_to: user || role
        const [ data, error ] = await request('put', `${$url}/${bv_assign_to}/assign_permission/${p_id}`, {
            target_id: bv_assign_target
        });
        if(!error) {
            role_permissions = data.role_permissions;
            user_permissions = data.user_permissions;
        }   
    }




    /* DELETE */
    async function removePermission(p) {
        const confirmed = await swalConfirm('Berechtigung entfernen', 'Soll die Berechtigung wirklich entfernt werden?', 'warning');
        if(confirmed) {
            const [ data, error ] = await request('delete', `${$url}/permission/remove/${p.id}`);
            if(!error) {
                filtered_permissions = filtered_permissions.filter(_p => _p.id != p.id);
                $permissions = filtered_permissions;
            }
        } 
    }

</script>


<div class="uk-container">
    <div class="uk-card uk-card-default uk-card-body uk-margin-top">
        <h3>{$_('permissions')}</h3>

        <ul class="uk-child-width-expand" uk-tab>
            <li>
                <a on:click={() => view = 'overview'}>{$_('overview')}</a>
            </li>
            <li>
                <a on:click={() => view = 'assign'}>{$_('assign')}</a>
            </li>
        </ul>

        <!-- zuweisung auswählen -->
        {#if view == 'assign'}
            <div class="uk-margin-bottom" uk-grid>
                <div class="uk-width-1-2">
                    <select class="uk-select" bind:value={bv_assign_to} on:change={() => changeAssign()}>
                        <option value="">{$_('assign')} {$_('to')}</option>
                        <option value="user">{$_('user')}</option>
                        <option value="role">{$_('user_role')}</option>
                    </select>
                </div>
                <div class="uk-width-1-2">
                    <select class="uk-select" bind:value={bv_assign_target} on:change={() => changeTarget()}>
                        <option value="">{$_('select')}</option>
                        {#if bv_assign_to == 'user'}
                            {#each $users as u}
                                <option value={u.id}>{u.firstname} {u.lastname}</option>
                            {/each}
                        {/if}
                        {#if bv_assign_to == 'role'}
                            {#each $roles as r}
                                <option value={r.id}>{r.name}</option>
                            {/each}
                        {/if}
                        <!--
                            each users bzw roles
                        -->
                    </select>
                </div>
            </div>
        {/if}

        {#if view == 'overview' || (view == 'assign' && bv_assign_to && bv_assign_target)}

            {#if !$permissions.length}
                <div class="uk-alert" uk-alert>
                    Keine Berechtigungen angelegt
                </div>
            {:else}
                <input type="text" class="uk-input" placeholder="{$_('search')}..." bind:value={bv_search} on:keyup={() => keyupSearch()} />

                <table class="uk-table uk-table-striped uk-table-small">
                    <thead>
                        <tr>
                            <th>
                                <span class="th-sort-icon" uk-icon=""></span>
                                {$_('name')}
                            </th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {#each filteredPermissions as p}
                            <tr>
                                <td data-sort={p.name}>
                                    <label class="c-pointer">
                                        {#if view == 'assign'}
                                            <input type="checkbox" class="uk-checkbox" on:click={() => asignPermission(p.id)} checked={hasPermission(p.id) ? true : false} />
                                            &nbsp;  
                                        {/if}
                                        {p.name}
                                    </label>
                                </td>
                                <td class="uk-text-right">
                                    {#if view == 'overview'}
                                        <span class="uk-margin-small-right c-pointer" uk-icon="pencil" uk-toggle="target: #m_edit_permission" on:click={() => setPermissionBinds(p)}></span>
                                        <span class="uk-text-danger c-pointer" uk-icon="trash" on:click={() => removePermission(p)}></span>
                                    {/if}
                                </td>
                            </tr>
                        {/each}
                    </tbody>
                </table>    
            {/if}

            {#if view == 'overview'}
                <div uk-grid>
                    <div class="uk-width-2-3@m">
                        <input type="text" placeholder="{$_('new-permission')}" class="uk-input" bind:value={bv_new_permission} on:keyup={e => e.key==='Enter' && savePermission()} />
                    </div>
                    <div class="uk-width-1-3@m">
                        <button class="uk-button uk-button-primary uk-float-right" on:click={() => savePermission()}>{$_('save')}</button>
                    </div>
                </div>
            {/if}
        {/if}


        <!-- Modals -->
        <div id="m_edit_permission" uk-modal>
            <div class="uk-modal-dialog">
                <button class="uk-modal-close-default" type="button" uk-close></button>
                <div class="uk-modal-header">
                    <h2 class="uk-modal-title">{$_('edit-permission')}</h2>
                </div>
                <div class="uk-modal-body">
                    <div uk-grid>
                        <div class="uk-width-1-1">
                            <label>{$_('name')}: <span class="uk-text-danger">*</span></label>
                            <input type="text" class="uk-input" bind:value={bv_edit_permission_name} />
                        </div>
                    </div>
                </div>
                <div class="uk-modal-footer uk-text-right">
                    <button class="uk-button uk-button-default uk-modal-close uk-margin-small-right uk-width-auto@s uk-width-1-1" type="button">{$_('cancel')}</button>
                    <button class="uk-button uk-button-primary uk-width-auto@s uk-width-1-1" on:click={() => updatePermission()}>{$_('save')}</button>
                </div>
            </div>
        </div>
    </div>
</div>